import { useSessionStore } from '@/hooks/useSessionStore';
import { RoleEnum } from '@/types/global';
import { useMemo } from 'react';
import { DefaultQualityValueMap } from '../components/SimpleEffects';

export const useDefaultQuality = () => {
  const { session } = useSessionStore();

  const qualityDefaultValue = useMemo((): string => {
    if (session?.user?.plan?.key) {
      const value = DefaultQualityValueMap[session.user.plan.key as RoleEnum];
      return value;
    }
    return 'mp3';
  }, [session?.user?.plan?.key]);

  return qualityDefaultValue;
};
